import React, { Component } from "react";
import { View, StyleSheet, Platform } from "react-native";
import Text from "./TextFont";
import { connect } from "react-redux";
import { IconButton } from "./Buttons";
import { IS_WEB } from "../locales/translate";
import PropTypes from "prop-types";
import { FONT_FAMILIES } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import LogIconButton from "./LogIconButton";
import { HStack } from "native-base";
import SliderBase from "../nativeBase-ui/SliderBase";
import Slider from "@react-native-community/slider";
import { getDir, getIsRTL } from "../util";
const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";
/**@augments{Component<props,state>} */
class Curtain extends Component {
  static propTypes = {
    deviceId: PropTypes.number.isRequired,
    deviceName: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    userValue: PropTypes.number.isRequired,
    onValueChange: PropTypes.func,
    style: PropTypes.shape(),
  };
  constructor(props) {
    super(props);
    this.state = {
      oldValue: this.props.value || 0,
      desireValue: this.props.userValue || this.props.value || 0, // value sat by user not by device event
    };
  }

  handleOnValueChange = (value) => {
    this.props.onValueChange && this.props.onValueChange(value);
  };

  changeValueTo = (value) => {
    this.setState(
      { desireValue: value, oldValue: this.props.value || 0 },
      () => {
        this.handleOnValueChange(value);
      }
    );
  };
  handleOnReportPress = () => {
    this.props.onReportPress && this.props.onReportPress();
  };
  render() {
    let defaultColor = "#6699CC";
    let _style = this.props.style || {};
    return (
      <View
        style={{
          backgroundColor: "#f0f0f0",
          // borderBottomColor: "#EEE",
          // borderBottomWidth: 1,
          // backgroundColor:Theme.COLORS.STATUS_BAR,

          padding: 5,
          // paddingVertical: 10,
          marginBottom: 10,
          borderRadius: 15,
          margin: 5,
          marginTop: 0,

          shadowColor: Theme.COLORS.BACKGROUND,
          shadowOffset: {
            width: 0,
            height: 3,
          },
          shadowOpacity: 0.2,
          shadowRadius: 6.65,
          elevation: 4,
          direction: getDir(),
          minWidth: 350,
          ..._style,
        }}
      >
        <View
          style={{
            flexDirection: "column",
            backgroundColor: Theme.COLORS.WHITE,
            padding: 15,
            borderRadius: 10,
            marginBottom: 15,

            shadowColor: Theme.COLORS.MUTED,
            shadowOffset: {
              width: 0,
              height: 3,
            },
            shadowOpacity: 0.2,
            shadowRadius: 6.65,
            elevation: 4,
          }}
        >
          <HStack space="2.5" alignItems="center">
            <LogIconButton onPress={this.handleOnReportPress} />
            <Text
              style={style.txtDeviceName}
              numberOfLines={1}
              ellipsizeMode="middle"
            >
              {this.props.deviceName}
            </Text>
          </HStack>
          <View
            style={[
              style.wrapper,
              { marginBottom: 0, padding: 0, justifyContent: "space-between" },
            ]}
          >
            <View style={style.iconButtonWrapperMini}>
              <IconButton
                onPress={() => {
                  if (this.state.desireValue >= 5) {
                    this.changeValueTo(this.state.desireValue - 5);
                  }
                }}
                style={{}}
                icon={{
                  code: "\uf068",
                  style: {
                    color: "#6699CC",
                    fontFamily: FONT_FAMILIES.PRO_REGULAR,
                    fontSize: 20,
                  },
                }}
              />
            </View>
            <View
              style={{
                // flexDirection: IsRTL ? "row-reverse" : "row",
                flexDirection: "row",
                // writingDirection: "ltr",
                minWidth: 80,
                justifyContent: "center",
                // marginHorizontal: 10,
                alignItems: "flex-end",
              }}
            >
              {this.props.userValue != undefined &&
                this.props.value != this.props.userValue && (
                  <Text style={style.txtCurrentValueSmall}>
                    {" "}
                    /{this.props.value}
                  </Text>
                )}
              <Text style={style.txtCurrentValue}>
                {this.state.desireValue}%
              </Text>
            </View>
            <View style={style.iconButtonWrapperMini}>
              <IconButton
                onPress={() => {
                  if (this.state.desireValue <= 95) {
                    this.changeValueTo(this.state.desireValue + 5);
                  }
                }}
                style={{}}
                icon={{
                  code: "\uf067",
                  style: {
                    color: "#6699CC",
                    fontFamily: FONT_FAMILIES.PRO_REGULAR,
                    fontSize: 20,
                  },
                }}
              />
            </View>
          </View>
        </View>

        <HStack space="5" alignItems="center" mb="3" px="3">
          <View style={style.iconButtonWrapper}>
            <IconButton
              onPress={() => this.changeValueTo(100)}
              style={{}}
              icon={{
                code: "\uf8fb",
                style: {
                  color: "#3266ff",
                  fontFamily: FONT_FAMILIES.PRO_REGULAR,
                  fontSize: 22,
                },
              }}
            />
          </View>
          <View style={{ flex: 1 }}>
            {IS_WEB ? (
              <SliderBase
                // isReversed={IS_MOBILE}
                // value={this.state.desireValue}
                style={{ paddingLeft: 10 }}
                defaultValue={this.state.desireValue}
                value={this.state.desireValue}
                minValue={0}
                maxValue={100}
                step={5}
                onChange={(v) => this.setState({ desireValue: v })}
                onChangeEnd={(v) => v >= 0 && this.changeValueTo(v)}
              >
                <SliderBase.Track shadow={2}>
                  <SliderBase.FilledTrack />
                </SliderBase.Track>
                <SliderBase.Thumb shadow={3} />
              </SliderBase>
            ) : (
              <Slider
                style={[style.slider, { transform: [{ scaleY: 5 }] }]}
                value={this.state.desireValue}
                step={1}
                minimumValue={0}
                maximumValue={100}
                minimumTrackTintColor={this.props.startColor || defaultColor}
                maximumTrackTintColor={Theme.COLORS.MUTED}
                thumbTintColor={"transparent"}
                thumbImage={"circle"}
                onValueChange={(v) => {
                  v >= 0 && this.setState({ desireValue: v });
                }}
                onSlidingComplete={(v) => {
                  this.changeValueTo(v);
                }}
                inverted={IS_MOBILE ? getIsRTL() : false}
              />
            )}
          </View>
          <View style={style.iconButtonWrapper}>
            <IconButton
              onPress={() => this.changeValueTo(0)}
              style={{}}
              icon={{
                code: "\uf8fd",
                style: {
                  color: "#6699CC",
                  fontFamily: FONT_FAMILIES.PRO_REGULAR,
                  fontSize: 22,
                },
              }}
            />
          </View>
        </HStack>
      </View>
    );
  }
}

const style = StyleSheet.create({
  txtCurrentValue: {
    textAlign: "left",
    writingDirection: "ltr",
    color: "#ccc",
    fontSize: 24,
    //marginHorizontal: 10,
  },
  txtCurrentValueSmall: {
    textAlign: "left",
    writingDirection: "ltr",
    color: "#ccc",
    fontSize: 12,
    //marginHorizontal: 10,
  },
  txtDeviceName: { textAlign: "center", color: "#333", fontSize: 18 },
  wrapper: {
    // flexDirection: IS_MOBILE ? "row-reverse" : "row",
    flexDirection: "row-reverse",
    justifyContent: "space-around",
    alignItems: "center",
    paddingHorizontal: 20,
    marginBottom: 10,
  },
  slider: {
    marginHorizontal: IS_MOBILE ? 12 : 5,
    height: 5,
  },
  iconButtonWrapper: {
    backgroundColor: "#e6e9f3",
    alignContent: "center",
    justifyContent: "center",
    width: 50,
    height: 50,
    borderRadius: 12,

    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  iconButtonWrapperMini: {
    alignContent: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: 28,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
  };
};

export default connect(mapStateToProps)(Curtain);
